import { render } from "./RestrictionRoads.htm?vue&type=template&id=0393cfad&scoped=true&ts=true"
import script from "./RestrictionRoads.vue?vue&type=script&lang=ts"
export * from "./RestrictionRoads.vue?vue&type=script&lang=ts"

import "./RestrictionRoads.scss?vue&type=style&index=0&id=0393cfad&lang=scss&scoped=true"

import exportComponent from "C:\\Projets\\FIFA\\Dev\\GIS-Dispatcher-Front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0393cfad"]])

export default __exports__